// @flow
import { createSelector, Selector } from 'reselect';
import Instadate from 'instadate';

export const selectCalendarEventsList: Selector<ReduxState, void, Option[]> = createSelector(
  state => state.CalendarReducer.Calendar.calendarEventsList,
  calendarEventsList => {
    if (Array.isArray(calendarEventsList) && calendarEventsList.length > 0) {
      return calendarEventsList;
    }
    return [];
  }
);

export const selectReservedEvents: Selector<ReduxState, void, Option[]> = createSelector(
  state => state.CalendarReducer.Calendar.events,
  state => state.CalendarReducer.Calendar.calendarEventsList,
  (events, eventsList) => {
    if (!Array.isArray(eventsList) || eventsList.length === 0) {
      return {};
    }
    const nextEvents = eventsList.reduce((acc, eventID) => {
      // Need from up perfomance disabled assign object
      acc[eventID] = {
        ...events[eventID],
        startTime: new Date(events[eventID].startTime),
        finishTime: new Date(events[eventID].finishTime),
        waitingList: [],
        positionInQueue: 0
      };
      return acc;
    }, {});

    // sort events by reserve 0 to 1 AND reservationModifyDate before to later
    eventsList.sort((a, b) => {
      const eventA = nextEvents[a];
      const eventB = nextEvents[b];
      if (
        eventA.reserve > eventB.reserve ||
        (eventA.reserve === eventB.reserve &&
          eventA.reservationModifyDate > eventB.reservationModifyDate)
      ) {
        return 1;
      }
      return -1;
    });

    // copy sort events list. Need from update events
    let sortByReservationModifyDate = [...eventsList];

    // update events value waitingList and positionInQueue
    eventsList.forEach(key1 => {
      sortByReservationModifyDate.forEach(key2 => {
        if (
          nextEvents[key1].id !== nextEvents[key2].id &&
          nextEvents[key2].reserve === '1' &&
          nextEvents[key2].resourcesList.every(eventID =>
            nextEvents[key1].resourcesList.includes(eventID)
          ) &&
          Math.min(nextEvents[key1].finishTime, nextEvents[key2].finishTime) -
            Math.max(nextEvents[key1].startTime, nextEvents[key2].startTime) >
            0
        ) {
          if (
            nextEvents[key1].reserve === '0' ||
            (nextEvents[key1].reserve === '1' &&
              parseInt(nextEvents[key1].positionInQueue, 10) === 0)
          ) {
            nextEvents[key1].waitingList.push(key2);
          }
          nextEvents[key2].positionInQueue += 1;
        }
      });
      sortByReservationModifyDate = sortByReservationModifyDate.filter(id => id !== key1);
    });

    const responseEvents = eventsList.reduce((acc, eventID) => {
      acc[eventID] = {
        ...events[eventID],
        waitingList: nextEvents[eventID].waitingList,
        positionInQueue: nextEvents[eventID].positionInQueue
      };
      return acc;
    }, {});
    return responseEvents;
  }
);

export const selectRightsShowCalendar: Selector<ReduxState, void, Option[]> = createSelector(
  state => state.CalendarReducer.Filter.filter,
  state => state.AccessGroupsReducer.accessGroups,
  (filter, accessGroups) => {
    const organizationID = filter ? filter.organizationID : null;
    if (organizationID && accessGroups) {
      const organizationAccess = accessGroups[organizationID];
      return organizationAccess ? organizationAccess.calendarView : false;
    }
    return false;
  }
);

export const selectEvents: Selector<ReduxState, void, Option[]> = createSelector(
  state => state.CalendarReducer.Calendar.events,
  events => events
);

export const selectAgendaEventsList: Selector<ReduxState, void, Option[]> = createSelector(
  selectEvents,
  state => state.CalendarReducer.Calendar.agendaEventsList,
  (events, agendaEventsList) => {
    if (events && Array.isArray(agendaEventsList) && agendaEventsList.length) {
      return agendaEventsList.sort((a, b) => {
        if (Instadate.isBefore(new Date(events[a].startTime), new Date(events[b].startTime))) {
          return -1;
        }
        return 1;
      });
    }
    return [];
  }
);
